import { Tag } from '../models/tag';
import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getClients(q: string) {
  return await axiosInstance.get<Tag[]>(
    `/clients?_start=0&_end=10&q=${q ?? ''}`,
    getDefaultRequestConfig()
  );
}
